import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import logoLight from "../assets/images/logoD2.png";
import logoDark from "../assets/images/logoD.png";

export default function Header({
  theme,
  lang,
  t,
  onToggleTheme,
  onToggleLang,
  onDownload,
  onScroll,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";

  const tr =
    typeof t === "function"
      ? t
      : (key) => {
          const fallback = {
            "nav.about": lang === "ar" ? "من نحن" : "About",
            "nav.app": lang === "ar" ? "التطبيق" : "App",
            "nav.awareness": lang === "ar" ? "التوعية" : "Awareness",
            "ui.lang_en": "English",
            "ui.lang_ar": "العربية",
            "nav.downloadApp": lang === "ar" ? "حمّل التطبيق" : "Download App",
          };

          return fallback[key] || key;
        };

  const goHomeTop = () => {
    if (isHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    navigate("/");

    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 120);
  };

  const handleSectionNav = (sectionId) => {
    if (isHome) {
      if (typeof onScroll === "function") onScroll(sectionId);
      return;
    }

    navigate("/");

    window.setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 180);
  };

  return (
    <header className="aq-nav">
      <div className="aq-container aq-nav-inner">
        <div
          className="aq-brand"
          role="button"
          tabIndex={0}
          onClick={goHomeTop}
          onKeyDown={(e) => e.key === "Enter" && goHomeTop()}
        >
          <img
            className="aq-logo"
            src={theme === "light" ? logoLight : logoDark}
            alt="Aman-QO"
          />

          <div className="aq-brand-text">
            <span className="aq-brand-name">Aman-QO</span>
            <span className="aq-brand-tag">
              {lang === "ar"
                ? "الأمان الرقمي… ببساطة"
                : "Digital safety… simply"}
            </span>
          </div>
        </div>

        <nav className="aq-links">
          <button onClick={() => handleSectionNav("about")} type="button">
            {tr("nav.about")}
          </button>

          <button onClick={() => handleSectionNav("app")} type="button">
            {tr("nav.app")}
          </button>

          <button onClick={() => handleSectionNav("awareness")} type="button">
            {tr("nav.awareness")}
          </button>

          <button
            onClick={() => handleSectionNav("achievements")}
            type="button"
          >
            {lang === "ar" ? "الإنجازات" : "Achievements"}
          </button>

          <button onClick={() => handleSectionNav("founders")} type="button">
            {lang === "ar" ? "الفريق" : "Team"}
          </button>

          <button onClick={() => navigate("/contact-us")} type="button">
            {lang === "ar" ? "تواصل معنا" : "Contact Us"}
          </button>
        </nav>

        <div className="aq-nav-cta">
          <button
            className="aq-btn aq-btn-ghost aq-theme-toggle"
            onClick={onToggleTheme}
            aria-label="Toggle theme"
            title={theme === "dark" ? "Light mode" : "Dark mode"}
            type="button"
          >
            <span className="aq-theme-ico" aria-hidden="true">
              {theme === "dark" ? "☀️" : "🌙"}
            </span>

            <span className="aq-theme-text">
              {theme === "dark"
                ? lang === "ar"
                  ? "فاتح"
                  : "Light"
                : lang === "ar"
                  ? "داكن"
                  : "Dark"}
            </span>
          </button>

          <button
            className="aq-btn aq-btn-ghost"
            onClick={onToggleLang}
            type="button"
          >
            {lang === "ar" ? tr("ui.lang_en") : tr("ui.lang_ar")}
          </button>

          {/* <button
            className="aq-btn aq-btn-solid aq-btn-download"
            onClick={onDownload}
            type="button"
          >
            {tr("nav.downloadApp")}
          </button> */}

          <button
            className="aq-btn aq-btn-solid aq-btn-download"
            onClick={() =>
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSfipFzR5_vkv-C0sZ3X6bzbRi0E0QiWLtMhuyIm5MG1ykMpeA/viewform",
                "_blank",
              )
            }
            type="button"
          >
            {lang === "ar" ? "التسجيل المسبق" : "Pre-registration"}
          </button>
        </div>
      </div>
    </header>
  );
}